<app-modal class="select-events-modal">
  <h1 class="h2">Select Events</h1>
  <div class="mt-0100 mb-0025">

    <div>
      <div class="event-filters flex flexJustify-between mt-0050 col__">
        <div class="flex quicksearch--simple">
          <mat-form-field class="quicksearch--simple__input ongray">
            <mat-label>Search</mat-label>
            <input matInput [formControl]="searchCtrl" type="search" autocomplete="off">
          </mat-form-field>
        </div>
        <mat-form-field class="flex ongray">
          <mat-label>Date range</mat-label>
          <mat-date-range-input [formGroup]="dateRangeFilter" [rangePicker]="customDateRangePicker">
            <input matStartDate (blur)="onDateChange()" formControlName="start" placeholder="Start date">
            <input matEndDate (blur)="onDateChange()" formControlName="end" placeholder="End date">
          </mat-date-range-input>
          <mat-datepicker-toggle matSuffix [for]="customDateRangePicker"></mat-datepicker-toggle>
          <mat-date-range-picker #customDateRangePicker (closed)="onDateChange()"></mat-date-range-picker>
        </mat-form-field>
      </div>
    </div>

    <app-event-list-select [loading]="eventsLoading" [events]="events" [selectedEventIds]="selectedEvents"
      (selectedEvents)="selectedEvents = $event"></app-event-list-select>

    <div class="row dual-btn-row with-gap mt-0100 flexJustify--end">
      <button type="button" class="btn btn--whiteRed mt-0" (click)="clearEvents()">
        Clear selections
      </button>
      <button type="button" class="btn mt-0" (click)="selectEvents()">
        Select {{ selectedEvents.length }} events
      </button>
    </div>
  </div>
</app-modal>
